import { useCallback, useMemo } from 'react'

import { Button } from 'antd'
import { Element } from 'html-react-parser'

type Props = {
  id: string
  node: Element
  shouldDisableButtons?: boolean
  handleAIChat?: (text: string) => void
}

const ParsedHtmlButton = ({ id, node, shouldDisableButtons, handleAIChat }: Props) => {
  const dataChatText = node.attribs['data-chat-text'] ?? ''
  const handleClick = useCallback(() => {
    if (shouldDisableButtons) {
      return
    }
    handleAIChat?.(dataChatText)
  }, [handleAIChat, dataChatText, shouldDisableButtons])
  const firstChild = node.children?.[0]
  const text = (firstChild?.type === 'text' ? firstChild.data : undefined) ?? 'Click'
  const buttonStyle = useMemo(
    () => ({
      whiteSpace: 'normal' as const,
      height: 'auto',
      textAlign: 'left' as const,
      maxWidth: '100%',
    }),
    []
  )
  return (
    <Button
      id={id}
      type="default"
      onClick={handleClick}
      disabled={shouldDisableButtons}
      className={shouldDisableButtons ? 'pointer-events-none' : ''}
      style={buttonStyle}
    >
      {text}
    </Button>
  )
}

export default ParsedHtmlButton
